<template>
    <div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
        <div class="card card-desc-tour shadow-lg mb-4">
            <div class="card-header bg-secondary" id="Info">
                <a data-toggle="collapse" class="collapsed" href="#collapseFilters" role="button" aria-expanded="true"
                   aria-controls="collapseFilters">
                    <h5 class="text-white m-0">
                        <i class="fas fa-list-ul fa-xs"></i>
                        Filters
                    </h5>
                </a>
            </div>
            <div class="card-body p-2 collapse collapse-card show" id="collapseFilters">
                <el-container style="border: 0px solid transparent">
                    <el-main style="background-color: white; overflow:hidden;" class="py-0 px-0">
                        <div class="col-md-12 col-sm-12 mb-2">
                            <el-row>
                                <p>{{$options.filters.translate('vue.textos_nombre')}} </p>
                                <el-input
                                    :placeholder="$options.filters.translate('vue.textos_nombre')"
                                    v-model="name"
                                    clearable
                                >
                                </el-input>
                            </el-row>
                        </div>
                        <div class="col-md-12 col-sm-12 mb-2">
                            <el-row>
                                <p>{{$options.filters.translate('vue.textos_pais')}} </p>
                                <el-select v-model="country" clearable filterable
                                           :placeholder="$options.filters.translate('vue.textos_pais')">
                                    <el-option
                                        v-for="(item, index) in countries"
                                        :key="index"
                                        :label="item"
                                        :value="index"
                                    >
                                    </el-option>
                                </el-select>
                            </el-row>
                        </div>
                        <div class="col-md-12 col-sm-12 mb-2">
                            <el-row>
                                <p>{{$options.filters.translate('vue.textos_region')}} </p>
                                <el-select v-model="region" clearable filterable
                                           :placeholder="$options.filters.translate('vue.textos_region')">
                                    <el-option
                                        v-for="(item, index) in regions"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-row>
                        </div>
                        <div class="col-md-12 col-sm-12 mb-2">
                            <el-row>
                                <p>{{$options.filters.translate('vue.textos_ciudad')}} </p>
                                <el-input
                                    :placeholder="$options.filters.translate('vue.textos_ciudad')"
                                    v-model="city"
                                    clearable
                                >
                                </el-input>
                            </el-row>
                        </div>
                    </el-main>
                </el-container>
            </div>
        </div>
    </div>
</template>

<script>
    import GeoAutocomplete from '../GeoAutocomplete.vue'

    export default {
        name: "SearchCompanies",
        components: {
            'vue-google-autocomplete': GeoAutocomplete,
            'geo-autocomplete': GeoAutocomplete,
        },
        props: ['page', 'parameters', 'countries', 'regions_old'],
        data() {
            return {
                name: '',
                regions: '',
                region: '',
                country: '',
                city: '',
            }
        },
        methods: {
            getCompanies() {
                this.$emit('loading-effect', true);
                axios.get(`/getCompaniesSearch?city=${this.city}&country_id=${this.country}&region_id=${this.region}&name=${this.name}&page=${this.page}`)
                    .then(res => {
                        // console.log(res.data);
                        this.$emit('companies', res.data);
                    })
                    .catch(e => {
                        console.log(e.response);
                    })
            },
            getRegions() {
                axios.get(`/getRegions/offer/${this.country}`)
                    .then(res => {
                        this.regions = res.data;
                    })
                    .catch(e => {
                        console.log(e.response);
                    })
            },
            issetParameters() {
                if (this.parameters.length !== 0) {
                    this.city = this.parameters['city'] ? this.parameters['city'] : '';
                    this.country = this.parameters['country_id'] ? this.parameters['country_id'] : '';
                    this.region = this.parameters['region_id'] ? parseInt(this.parameters['region_id']) : '';
                    this.name = this.parameters['name'] ? this.parameters['name'] : '';
                }
            },
            trans(value) {
                if (!value) return '';
                return _.get(window.i18n, value);
            },
        },
        filters: {
            translate: function (value) {
                if (!value) return '';
                return _.get(window.i18n, value);
            }
        },
        created() {
            this.regions = this.regions_old;
            const issetParameters = this.issetParameters();
            const promise = fetch(issetParameters);
            promise.then(result => this.getCompanies(),
                e => console.log(`Error capturado:  ${e}`));
        },
        watch: {
            name() {
                this.getCompanies();
            },
            region() {
                this.getCompanies();
            },
            city() {
                this.getCompanies();
            },
            country() {
                this.getCompanies();
                this.getRegions();

            },
            page() {
                if (this.page) {
                    this.getCompanies();
                }
            }
        }
    }
</script>

<style scoped>

</style>
